export const analyticsTrack = async (key: string, value?: string | object): Promise<boolean> => {
  /**
   * ANALYTICS TRACKING relays on the presence of external "_satellite()" function
   * Loaded from CDN https://assets.adobedtm.com/launch-EN578e54a3f0c6478aa41c89022e30863c.min.js inside DIV ID "dtm_script"
   * TS doesn't know of its existence, so...
   */
  console.log('[analytics-track.ts] LMP analyticsTrack', { key, value });
  // @ts-ignore for _satellite.track() (loaded from external lib inside AEM template)
  const satellite = window._satellite;
  const fn = () => {
    if (!value) {
      satellite.track(key);
      return;
    }
    if (typeof value === 'string') {
      satellite.track(key, { value });
      return;
    }
    satellite.track(key, value);
  };
  return setTimedInterval(fn, `'key=${key}, value=${JSON.stringify(value)}'`);
};

export const setTimedInterval = async (
  callback: Function,
  message?: string,
  delay: number = 1000,
  iterations: number = 10
): Promise<boolean> => {
  return new Promise(async (resolve, reject) => {
    let x = 0;
    const intervalID = setInterval(async () => {
      try {
        await callback();
        clearInterval(intervalID);
        // console.log(`[analytics-track.ts] LMP OK - Interval ${intervalID} cleared`);
        resolve(true);
      } catch (err) {
        // console.log('the error is', err);
        // Surrender after all failed attempts
        if (++x >= iterations) {
          // eslint-disable-next-line no-console
          console.error(
            `[analytics-track.ts] LMP Function${
              message ? ` called with params ${message}` : ''
            } returned error after ${iterations} tries!`,
            err.toString()
          );
          clearInterval(intervalID);
          // console.log(`[analytics-track.ts] LMP KO - Interval ${intervalID} cleared`);
          reject(new Error(`Function${message ? ` called with params ${message}` : ''} not found!`));
        } else if (x === 1) {
          // eslint-disable-next-line no-console
          console.warn(
            `[analytics-track.ts] LMP Called function${
              message ? ` with params ${message}` : ''
            } returned error, will try again in ${delay / 1000} seconds for another ${iterations - x} times...`
          ); // One WARNING only, to avoid polluting the console...
        }
      }
    }, delay);
  });
};

const trackDigitalData = (menu: HTMLElement | null): any => {
  const tabName = menu?.getAttribute('data-active-tab')?.toLowerCase() || '';
  const satelliteTabTrack = { tab_label: tabName };
  analyticsTrack('cambio_tab', satelliteTabTrack)
    .then((value) => console.log('[analytics-track.ts]', 'cambio_tab', value)) // eslint-disable-line no-console
    .catch((err) => console.warn('[analytics-track.ts]', 'cambio_tab', err)); // eslint-disable-line no-console
};

const tabAddClickListener = (tab: HTMLElement, menu: HTMLElement | null): void => {
  tab.addEventListener('click', (e) => {
    trackDigitalData(menu);
  });
};

export const trackPageViews = (): void => {
  const menu: HTMLElement | null = document.querySelector('div[data-active-tab]');

  if (menu) {
    const menuItems: HTMLCollection = menu.children;
    Array.from(menuItems).forEach((tab: HTMLElement) => tabAddClickListener(tab, menu));
  }
};
